import { faTriangleExclamation } from '@fortawesome/pro-thin-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { React } from '../../Imports';
import { isEncompass } from '$Utilities/integrationPlatform';

const styles = require('./SiteUnavailable.scss') as {
    pageWrapperGeotab: string;
    pageWrapperEncompass: string;
    contentColumnGeotab: string;
    contentColumnEncompass: string;
    iconWrapperGeotab: string;
    iconWrapperEncompass: string;
    headerGeotab: string;
    contentGeotab: string;
    phoneNumberGeotab: string;
    headerEncompass: string;
    contentEncompass: string;
    phoneNumberEncompass: string;
};

export const SiteUnavailable = () => {
    return (
        <div className={isEncompass ? styles.pageWrapperEncompass : styles.pageWrapperGeotab}>
            <div className={isEncompass ? styles.contentColumnEncompass : styles.contentColumnGeotab}>
                <span className={isEncompass ? styles.iconWrapperEncompass : styles.iconWrapperGeotab}>
                    <FontAwesomeIcon icon={faTriangleExclamation} />
                </span>
                <h1 className={isEncompass ? styles.headerEncompass : styles.headerGeotab}>Oh no! Something's broken.</h1>
                <p className={isEncompass ? styles.contentEncompass : styles.contentGeotab}>
                    Don't worry — it's not you. It's likely we're already working on this issue.
                    <br />
                    Please wait 30 minutes and try reloading the page. If the link doesn't work, please give us a call at
                </p>
                <p className={isEncompass ? styles.phoneNumberEncompass : styles.phoneNumberGeotab}>1-833-933-0971</p>
                <p className={isEncompass ? styles.contentEncompass : styles.contentGeotab}>Monday through Friday 7:30 AM – 4:30 PM CDT.</p>
            </div>
        </div>
    );
};
